/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SunIcon
 */
export default class SunIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 19a1 1 0 01.993.883L13 20v3a1 1 0 01-1.993.117L11 23v-3a1 1 0 011-1zm6.613-1.79l.094.083 2 2a1 1 0 01-1.32 1.497l-.094-.083-2-2a1 1 0 011.32-1.497zm-13.32.083a1 1 0 111.414 1.414l-2 2a1 1 0 11-1.414-1.414zM12 6a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8zm-8 3a1 1 0 01.117 1.993L4 13H1a1 1 0 01-.117-1.993L1 11h3zm19 0a1 1 0 01.117 1.993L23 13h-3a1 1 0 01-.117-1.993L20 11h3zM4.613 3.21l.094.083 2 2a1 1 0 01-1.32 1.497l-.094-.083-2-2a1 1 0 011.32-1.497zm16.094.083a1 1 0 01.083 1.32l-.083.094-2 2a1 1 0 01-1.497-1.32l.083-.094 2-2a1 1 0 011.414 0zM12 .5a1 1 0 01.993.883L13 1.5V4a1 1 0 01-1.993.117L11 4V1.5a1 1 0 011-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

